export const money = (n) => new Intl.NumberFormat("fr-FR").format(n) + " DA";

export const int = (n) => new Intl.NumberFormat("fr-FR").format(n);

export const date = (s) => {
  if (!s) return "—";
  const dt = new Date(s);
  return dt.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
};

export const datetime = (s) => {
  if (!s) return "—";
  const dt = new Date(s);
  return (
    dt.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" }) +
    " · " +
    dt.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
  );
};

export const relative = (s) => {
  if (!s) return "—";
  const diff = (Date.now() - new Date(s).getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 86400 * 7) return `il y a ${Math.floor(diff / 86400)} j`;
  return date(s);
};
